var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"feedbtn",on:{"click":function($event){$event.preventDefault();return _vm.activateUserHelp.apply(null, arguments)}}},[_vm._v(" Feedback ")])
}
var staticRenderFns = []

export { render, staticRenderFns }